import * as React from 'react';
/**
 *
 * Original name: upload
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=46273%3A54
 *
 */
export const UploadSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { d: "M57.002 15.527v.195l-.018-.003c-1.5 7.844-9.699 24.641-29.624 31.604l1.98 5.664c13.649-4.77 22.458-13.654 27.662-22.009v56.599h6V30.965c5.202 8.359 14.014 17.25 27.67 22.022l1.98-5.664c-19.926-6.963-28.125-23.76-29.625-31.604l-.025.005v-.197h-6Zm-44.018 88.446h94.032v-6H12.984v6Z", fill: "currentColor" })));
